import React from 'react';

const LogoMarqueeItem = ({ logo, duplicateIndex }) => (
  <div
    className="site-refresh__logo-item"
    aria-hidden={duplicateIndex > 0 ? true : undefined}
  >
    <img
      className="site-refresh__logo-image"
      src={encodeURI(logo.src)}
      alt={duplicateIndex === 0 ? logo.name : ''}
      loading="lazy"
      decoding="async"
    />
  </div>
);

const PreviewLogoStrip = ({ logos }) => {
  const marqueeLogos = [...logos, ...logos];

  return (
    <section className="site-refresh__section site-refresh__section--logos">
      <div className="site-refresh__shell">
        <div className="site-refresh__logo-heading">Quem confia</div>
      </div>

      <div className="site-refresh__logo-marquee" aria-label="Marcas parceiras">
        <div className="site-refresh__logo-marquee-track">
          {marqueeLogos.map((logo, index) => (
            <LogoMarqueeItem
              key={`${logo.name}-${index}`}
              logo={logo}
              duplicateIndex={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PreviewLogoStrip;
